// Caps console.error volume for errors that can repeat every poll cycle during an outage, without affecting retry behavior.
export function createThrottledLogger(windowMs: number) {
  let lastLoggedAt = 0;
  return (...args: unknown[]) => {
    const now = Date.now();
    if (now - lastLoggedAt < windowMs) return;
    lastLoggedAt = now;
    console.error(...args);
  };
}
